import { Component, OnInit, Input } from '@angular/core';
import { Editorcontrolitem } from '../models/editorcontrolitem.model';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { BaseComponent } from '../base.component';
import { DataService } from '../service/data.service';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.less']
})
export class ControlComponent extends BaseComponent implements OnInit {

  @Input() item: Editorcontrolitem;
  settings : any;

  constructor(data:DataService) 
  {
    super(data);
  }

  ngOnInit() {
    //alert(this.item.Type);

     this.settings = JSON.parse(this.item.SettingsJson);
  }

  drop(event: CdkDragDrop<string[]>) {
      alert("OK");
    //moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
  }

  changeSelectedItem(event: any){
      this.data.selectedItem = this.item;
      this.data.prepareTmpItem();
      event.stopPropagation();
  }

}
